const stationNamePattern = /^station\s+0*([1-9]\d*)$/iu;

function normalizedName(value: string): string {
  return value.trim().replace(/\s+/gu, ' ').toLocaleLowerCase('en-US');
}

export function allocateStationNames(existingNames: readonly string[], count = 1): string[] {
  const requestedCount = Number.isFinite(count) ? Math.max(0, Math.floor(count)) : 0;
  if (requestedCount === 0) return [];

  const occupied = new Set(existingNames.map(normalizedName));
  let highestNumber = 0;
  for (const existingName of existingNames) {
    const match = existingName.trim().match(stationNamePattern);
    if (!match) continue;
    const number = Number(match[1]);
    if (Number.isSafeInteger(number)) highestNumber = Math.max(highestNumber, number);
  }

  const names: string[] = [];
  let candidate = highestNumber < Number.MAX_SAFE_INTEGER ? highestNumber + 1 : 1;
  while (names.length < requestedCount) {
    const name = `Station ${candidate}`;
    candidate = candidate < Number.MAX_SAFE_INTEGER ? candidate + 1 : 1;
    if (occupied.has(normalizedName(name))) continue;
    occupied.add(normalizedName(name));
    names.push(name);
  }
  return names;
}

export interface PtMpStationIdentity {
  stationNumber: number;
  siteId: string;
  linkId: string;
}

export function allocatePtMpStationIdentity(groupId: string, existingSiteIds: readonly string[], existingLinkIds: readonly string[]): PtMpStationIdentity {
  const occupiedSiteIds = new Set(existingSiteIds);
  const occupiedLinkIds = new Set(existingLinkIds);
  let stationNumber = 1;
  while (occupiedSiteIds.has(`${groupId}-s${stationNumber}`) || occupiedLinkIds.has(`${groupId}:station:${stationNumber}`)) stationNumber += 1;
  return { stationNumber, siteId: `${groupId}-s${stationNumber}`, linkId: `${groupId}:station:${stationNumber}` };
}
